export const CLOSE_ALERT_MODAL = 'CLOSE_ALERT_MODAL'
export const SHOW_ALERT_MODAL = 'SHOW_ALERT_MODAL'

export const showPopupAlert = ({ message, title }) => {
  return { type: SHOW_ALERT_MODAL, message, title }
}

export const hidePopupAlert = () => ({ type: CLOSE_ALERT_MODAL })
